
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import store from "@/state/store";
var state = store._modules.root._children.auth.state;
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      DmWeightTargets: [],
      page: 1,
      limit: 20,
      driver_id: 0,
      tot_pages: 0,
      searchDmWeightTargets: null,
      DmWeightTargetsSearchMode: false,
      searchModel: "",
      state: state,
    };
  },
  methods: {
    addDmWeightTargets() {
      console.log("**********####", this.state);
      var data = {
        title: "popups.addDmWeightTargets",
        inputs: [
       
          { model: "month", type: "number", label: "dm_weight_targets.month" },
          { model: "weight", type: "number", label: "dm_weight_targets.weight" }
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.delivery_man_id=this.driver_id
              this.http.post("dm-weight-targets", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editDmWeightTargets(app) {
      var data = {
        title: "popups.dm_weight_targets",
        inputs: [
          {
            model: "delivery_man_id",
            type: "text",
            label: "dm_weight_targets.delivery_man_id",
            value: app.delivery_man_id,
          },
          {
            model: "month",
            type: "text",
            label: "dm_weight_targets.month",
            value: app.month,
          },
          {
            model: "weight",
            type: "text",
            label: "dm_weight_targets.weight",
            value: app.weight,
          },
          {
            model: "created_at",
            type: "text",
            label: "dm_weight_targets.created_at",
            value: app.created_at,
          },
          {
            model: "updated_at",
            type: "text",
            label: "dm_weight_targets.updated_at",
            value: app.updated_at,
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("dm-weight-targets", app.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    updateDmWeightTargets(app) {
      var data = {
        title: "popups.editfile",
        inputs: [
          {
            model: "delivery_man_id",
            type: "text",
            label: "dm_weight_targets.delivery_man_id",
          },
          { model: "month", type: "text", label: "dm_weight_targets.month" },
          { model: "weight", type: "text", label: "dm_weight_targets.weight" },
          {
            model: "created_at",
            type: "text",
            label: "dm_weight_targets.created_at",
          },
          {
            model: "updated_at",
            type: "text",
            label: "dm_weight_targets.updated_at",
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.emp_id = app.id;
              this.http.do("dm-weight-targets", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    search() {
      this.DmWeightTargetsSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("dm-weight-targets/search", {
          search: this.searchModel,
          limit: this.limit,
          page: this.page,
          col: "",
        })
        .then((res) => {
          this.DmWeightTargets = res.data;
          console.log("######## files", this.DmWeightTargets);
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.DmWeightTargetsSearchMode = false;
      this.get(this.page);
    },

    getDmWeightTargets() {
      this.http.get("dm-weight-targets").then((res) => {
        this.DmWeightTargets = res.data;
      });
    },
    deleteDmWeightTargets(app) {
      var data = {
        title: "popups.deletefile",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          console.log("###");
          this.http.delete("dm-weight-targets", app.id).then(() => {
            console.log("############################3");
            this.get(this.page);
          });
        }
      });
    },

    get(page) {
      console.log(page);
      this.http
        .post("dm-weight-targets/paginate", {
          limit: this.limit,
          driver_id: this.driver_id,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.DmWeightTargets = res.data;
        });
    },
  },
  created() {
    this.driver_id = this.$route.params.id;
    this.get(1);
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.dm_weight_targets.text')"
    />
    <div class="row">
      <div class="col-6">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @keyup="search()"
              type="text"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <button
          class="btn-close text-light"
          v-if="DmWeightTargetsSearchMode"
          @click="cancelappsearchMode()"
        ></button>
        <button
          type="button"
          @click="addDmWeightTargets()"
          class="btn btn-light float-end mb-4"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>

    <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
          <th scope="col">{{ $t("dm_weight_targets.id") }}</th>
          <th scope="col">{{ $t("dm_weight_targets.month") }}</th>
          <th scope="col">{{ $t("dm_weight_targets.weight") }}</th>
          <!-- <th scope="col">{{ $t("dm_weight_targets.created_at") }}</th> -->
          <!-- <th scope="col">{{ $t("dm_weight_targets.updated_at") }}</th> -->
          <th scope="col">{{ $t("dm_weight_targets.operations") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(app,index) in DmWeightTargets" :key="app" class="text-center">
          <td>{{ index+1 }}</td>
          <td>{{ app.month }}</td>
          <td >{{ app.weight }}</td>
          <!-- <td>{{ app.created_at }}</td> -->
          <!-- <td>{{ app.updated_at }}</td> -->

          <td colspan="2">
            <a
              class="btn btn-primary mx-1"
              @click="editDmWeightTargets(app)"
              href="javascript: void(0);"
              role="button"
              >{{ $t("popups.edit") }}</a
            >
            <a
              class="btn btn-danger"
              href="javascript: void(0);"
              role="button"
              @click="deleteDmWeightTargets(app)"
              >{{ $t("popups.delete") }}</a
            >
          </td>
        </tr>
      </tbody>
    </table>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <div v-if="tot_pages == 20">
      <!--   Apps  paginate     -->
      <ul class="paginate paginate-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
            p
          }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page == total_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--end-->
  </Layout>
</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>




